import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { PageHeader } from "../components/shared/PageHeader";
import { CTASection } from "../components/shared/CTASection";
import { BLOG, IMAGES } from "../data/content";

export default function Blog() {
  const [featured, ...rest] = BLOG;
  return (
    <div data-testid="blog-page">
      <PageHeader
        testId="blog-header"
        eyebrow="Insights"
        title="Perspectives on aviation safety, operations and AI."
        subtitle="Practical thinking for aviation leaders — from audit readiness and AI adoption to the growth opportunity in Africa."
        image={IMAGES.ai}
      />

      <section className="bg-background py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <Link to={`/insights/${featured.slug}`} data-testid="blog-featured" className="group grid overflow-hidden rounded-3xl border border-border bg-white lg:grid-cols-2">
              <div className="relative h-64 lg:h-auto">
                <img src={IMAGES[featured.image]} alt={featured.title} className="absolute inset-0 h-full w-full object-cover" />
              </div>
              <div className="flex flex-col justify-center p-8 lg:p-12">
                <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-wide text-aero">
                  <span>{featured.category}</span><span className="text-muted-foreground">· {featured.readTime}</span>
                </div>
                <h2 className="mt-4 font-display text-2xl font-extrabold tracking-tight text-navy lg:text-3xl">{featured.title}</h2>
                <p className="mt-4 text-sm leading-relaxed text-muted-foreground lg:text-base">{featured.excerpt}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-brand transition-transform group-hover:translate-x-1">
                  Read insight <ArrowRight className="h-4 w-4" />
                </span>
              </div>
            </Link>
          </Reveal>

          <div className="mt-10 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {rest.map((post, i) => (
              <Reveal key={post.slug} delay={i * 0.08}>
                <Link to={`/insights/${post.slug}`} data-testid={`blog-card-${post.slug}`} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-border bg-white transition-transform hover:-translate-y-1 hover:shadow-xl">
                  <div className="relative h-48"><img src={IMAGES[post.image]} alt={post.title} className="absolute inset-0 h-full w-full object-cover" /></div>
                  <div className="flex flex-1 flex-col p-6">
                    <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-aero">
                      <span>{post.category}</span><span className="text-muted-foreground">· {post.readTime}</span>
                    </div>
                    <h3 className="mt-3 font-display text-lg font-bold text-navy">{post.title}</h3>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{post.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand transition-transform group-hover:translate-x-1">
                      Read more <ArrowRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
